// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MuAx","colMin":"styles_colMin__2gFYl"};